var tabsI18n = {
  requirementsErrorTitle: 'Requirements do not match',
  toggleButtonAriaLabel: 'Toggle password visibility'
};
export default tabsI18n;